/**
 * @file NumericalConditionCell.tsx
 * @description cellType = NumericalCondition 时的入口（仅数值条件，无条形）。
 *
 * 建列时由 applyConditionalFormatToColumn 设置 cellType；
 * 实现上直接复用 NumericalValueContent，保持与「条+数值」叠加层一致的前景渲染。
 */

import React from 'react';

import type { IAliTableCellComponentProps } from '@customComp/AliTableAnalytics/types';
import NumericalValueContent from './NumericalValueContent';

const NumericalConditionCell: React.FC<IAliTableCellComponentProps> = props => {
  const { text, row, column } = props;
  return <NumericalValueContent text={text} row={row} column={column} />;
};

export default NumericalConditionCell;
